import { useState, useRef, useEffect } from "react";
import styles from "./CustomSelect.module.css";
import { cx } from "../../../Util/classHelpers";

const CustomSelect = ({ options, onSelect, selected, selectClassName, optionClassName, selectedOptionClassName, wrapperClassName, label = null, displayFunc = (o) => o.label }) => {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find(o => o.value === selected) || (label ? null : options[0]);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setOpen(false);
    if (onSelect) onSelect(option.value);
  };

  return (
    <div ref={ref} className={cx(styles.selectWrapper, wrapperClassName)}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={cx(styles.selectButton, selectClassName)}
        data-options-open={open}
        data-selected={selectedOption !== null}
      >
        <span className={styles.selectLabel}>
          {selectedOption !== null ? displayFunc(selectedOption) : label}
        </span>
        <span className={styles.selectArrow}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 8L10 12L14 8"
              stroke="#4A4A4A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      {open && (
        <div className={styles.selectDropdown}>
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option)}
              className={cx(
                styles.selectOption,
                selectedOption?.value === option.value && styles.selectOptionSelected,
                optionClassName,
                selectedOption?.value === option.value && selectedOptionClassName
              )}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect; 
